import {Children, type ReactNode} from 'react';
import {cn} from '../lib/cn';

type NumberedListProps = {
  children?: ReactNode;
  className?: string;
  itemClassName?: string;
};

const NumberedList = ({children, className, itemClassName}: NumberedListProps) => {
  const items = Array.isArray(children) ? Children.toArray(children) : [children];

  return (
    <ol
      className={cn(
        'm-0 flex w-full list-none flex-col gap-4 p-0 [counter-reset:item]',
        className,
      )}
      type="1"
    >
      {items.map((child, index) => (
        <li
          key={index}
          className={cn(
            'grid grid-cols-[1.5rem_1fr] items-start gap-2 [counter-increment:item]',
            `before:relative before:flex before:h-6 before:w-6 before:-translate-y-0.5
            before:items-center before:justify-center before:rounded-full
            before:bg-[var(--numbered-list-marker-bg)] before:text-sm before:font-semibold before:leading-6
            before:text-[var(--numbered-list-marker-text)] before:content-[counter(item)]`,
            itemClassName,
          )}
        >
          <div>{child}</div>
        </li>
      ))}
    </ol>
  );
};

export {NumberedList};
export type {NumberedListProps};
